<div
  class="tw-max-w-72 tw-rounded-2xl tw-bg-white tw-p-6 tw-shadow-xl md:tw-max-w-md lg:tw-max-w-xl"
  role="dialog"
  aria-labelledby="bulk-enable-dialog-title"
>
  <!-- Header -->
  <h4
    class="tw-mb-4 tw-font-extrabold tw-text-neutral-900"
    id="bulk-enable-dialog-title"
  >
    {{
      enable
        ? i18n.Automation_EnableAutomations
        : i18n.Automation_DisableAutomations
    }}
  </h4>

  <!-- Body -->
  <div class="tw-max-h-[60vh] tw-overflow-auto">
    @if (inactionableAutomations?.length > 0) {
      <div
        class="tw-mb-4 tw-flex tw-gap-2 tw-rounded-lg tw-bg-warning-100 tw-p-3 tw-text-warning-900"
      >
        <da-icon
          icon="exclamation-circle"
          type="solid-small"
          class="tw-shrink-0"
          aria-hidden="true"
        />
        <div aria-live="polite">
          <div class="tw-text-sm">
            {{ i18n.Automation_BulkEnable_SomeRulesInvalidWarning }}
          </div>
          @if (inactionableAutomations) {
            <ul class="tw-mt-1 tw-list-disc tw-pl-4 tw-text-sm">
              @for (
                automation of visibleInactionableAutomations();
                track automation
              ) {
                <li class="tw-break-words">
                  {{ automation.ruleName }}
                </li>
              }
            </ul>
          }
          @if (inactionableAutomations?.length > 5) {
            <button
              class="tw-mt-1 tw-text-sm tw-text-warning-900 tw-underline"
              type="button"
              (click)="toggleShowAllInactionable()"
            >
              {{ showAllInactionable ? i18n.Core_Collapse : i18n.Core_ShowAll }}
            </button>
          }
        </div>
      </div>
    }

    <div class="tw-mb-2 tw-text-neutral-900">
      <span class="tw-break-words">{{ confirmationMessage }}</span>
    </div>

    <div class="tw-mb-6">
      @if (actionableAutomations) {
        <ul class="tw-list-disc tw-pl-4 tw-text-sm">
          @for (automation of actionableAutomations; track automation) {
            <li class="tw-break-words">
              {{ automation.ruleName }}
            </li>
          }
        </ul>
      }
    </div>
  </div>

  <!-- Footer -->
  <div class="tw-flex tw-justify-end tw-gap-4">
    <button
      type="button"
      (click)="onDismiss()"
      class="tw-btn-secondary-outline tw-btn-medium"
      data-dgat="bulk-enable-modal-cancel-btn"
    >
      {{ i18n.Core_Cancel }}
    </button>
    <button
      type="button"
      (click)="onConfirm()"
      class="tw-btn-primary tw-btn-medium"
      data-dgat="bulk-enable-modal-confirm-btn"
    >
      {{ enable ? i18n.Core_Enable : i18n.Core_Disable }}
    </button>
  </div>
</div>
